import store from '../../store/index';
import { objectToQueryParams } from 'utils';
import { browserAssetToCampaignAsset } from 'modules/Campaigns/utils';
import { setOnBoardingStepService } from 'modules/Services/LoginService';
import { removeSelectedIds, setHoveredAssetId } from 'modules/Content/DragnDrop/actions';
import { resetWorkflow, updateAnEmailInEmailListingAnalytics } from 'modules/Automation/actions';
import { serializeEmailBrowserEmails, serializeEmailBrowserCuratedResponse, getQueryEmailId } from './utils';
import {
  createNewEmailService,
  getEmailBrowserListService,
  undoCurationFromEmailService,
  createNewDraftForAssetService,
  searchBrowserAssetListService,
  deleteNewlyCreatedDraftService,
  getBrowserAssetsForCampaignService,
  removeEmailFromEmailBrowserListService,
  searchBrowserAssetListInCampaignService,
  addArticlesToEmailInEmailBrowserService,
  updateEmailNameService,
} from '../Services/EmailBrowserService';
import {
  AIEMAIL,
  EMAIL_LIST,
  CAMPAIGNS_LIST,
  ON_BOARDING_ENUMS,
  EMAIL_BROWSER_ON_BOARDING,
  ASSET_DETAILS_REMOVE_DRAFT,
  ASSET_DETAILS_ADD_NEW_DRAFT,
  EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT,
} from 'constants/types';
import {
  DESIGN,
  DRAG_DROP,
  WHN_ARTICLES,
  FAVORITE_NEWS,
  EMAIL_BROWSER,
  SEARCH_ARTICLES,
  GENERATE_PREVIEW,
  EMAIL_BROWSER_ADD_EMAIL,
  ALL_ARTICLES_IN_EDITION,
  EMAIL_BROWSER_ADD_ARTICLES,
  BROWSER_CREATE_ASSET_DRAFT,
  GET_ALL_ASSETS_IN_CAMPAIGN,
  BROWSER_REMOVE_ASSET_DRAFT,
  BROWSER_CREATED_ASSET_DRAFT,
  EMAIL_BROWSER_CURATION_UNDO,
  BROWSER_ADD_ASSET_WITH_CAMPAIGN,
  EMAIL_BROWSER_EMAILS_IN_CAMPAIGN,
  EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL,
  BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN,
} from '../../constants/actionTypes';

//*  adding to the draft of a version
export const createBrowserAssetDraft = (assetId: number, selectedArticles: string) => {
  const count = selectedArticles.split(',').length;
  store.dispatch({
    type: BROWSER_CREATE_ASSET_DRAFT.ADD,
  });
  try {
    createNewDraftForAssetService(assetId, selectedArticles)
      .then((res) => {
        if (res.data?.success === false) {
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT.ADD_FAIL,
            payload: [],
          });
        } else if (res.status === 200) {
          let updated_date = '';
          if (res.data?.updated_on === null || res.data?.updated_on === undefined) {
            let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            let date = new Date();
            let month = months[date.getMonth()];
            let day = date.getDate();
            updated_date = day + ' ' + month;
          } else {
            updated_date = res.data?.updated_on;
          }
          const newDraftEdition = {
            version_id: res.data?.edition_id,
            subject: res.data?.name,
            name: res.data?.name,
            status: 'draft',
            last_update: updated_date,
            sent_date: res.data?.creation_time?.length > 8 ? null : res.data?.creation_time,
            thumbnail: [res.data?.image],
            total_contacts: 0,
            total_sent: 0,
            total_delivery: 0,
            total_open: 0,
            total_clicks: 0,
            curated_articles_count: count,
            a_or_b: 'a',
            description: '',
            title: '',
            link: '',
          };

          store.dispatch({
            type: ASSET_DETAILS_ADD_NEW_DRAFT.SUCCESS,
            newDraft: newDraftEdition,
          });
          const edition = {
            ...res.data,
            newlyCreated: true,
            articles_count: count,
            showUndo: true,
            recentlyAddedArticles: selectedArticles,
          };
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT.ADD_SUCCESS,
            payload: { edition, assetId },
          });
          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES.RESET_UNDO,
              payload: {
                articleId: assetId,
                editionId: edition.edition_id,
              },
            });
          }, 30000);
          setTimeout(() => {
            store.dispatch({ type: BROWSER_CREATE_ASSET_DRAFT.RESET });
          }, 3000);
        } else {
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT.ADD_FAIL,
            payload: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
        console.log('OKAY SO WE FAILED TO ADD BROWSER ASSET');
        store.dispatch({
          type: BROWSER_CREATE_ASSET_DRAFT.ADD_FAIL,
          payload: [],
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log('CATCH: adding to the draft of an article');
  }
};

//* create new mail with campaign
export const createBrowserAssetWithCampaign = (articles: string, campaignId: string) => {
  store.dispatch({
    type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD,
  });
  try {
    createNewEmailService(articles, campaignId)
      .then((res) => {
        if (res.data?.success === false) {
          store.dispatch({
            type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_FAIL,
            payload: [],
          });
        } else if (res.status === 200) {
          store.dispatch({
            type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_SUCCESS,
            payload: res.data,
          });
          const assetCardInCampaign: any = browserAssetToCampaignAsset(res.data, campaignId);
          console.log('PRINITNG THE BROWSER ASSETS AFTER SERIALZIER');
          console.log(assetCardInCampaign);
          store.dispatch({
            type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_ASSET_IN_CAMPAIGN,
            payload: assetCardInCampaign,
          });
          // made a function to highlight and change count on asset browser sidebar
          updateAssetCountSidebarIcon(true);
        } else {
          store.dispatch({
            type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_FAIL,
            payload: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
        console.log('OKAY SO WE FAILED TO ADD BROWSER ASSET');
        store.dispatch({
          type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_FAIL,
          payload: [],
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log("CATCH: couldn't add new assets to the campaign");
  }
};

//*  adding to the draft of a version
export const createBrowserAssetDraftWithoutCampaign = (assetId: number, selectedArticles: string) => {
  console.log('create browser asset draft without campaign');
  const count = selectedArticles.split(',').length;
  store.dispatch({
    type: BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD,
  });
  try {
    createNewDraftForAssetService(assetId, selectedArticles)
      .then((res) => {
        if (res?.status === 200) {
          const edition = {
            ...res.data,
            newlyCreated: true,
            articles_count: count,
            showUndo: true,
            recentlyAddedArticles: selectedArticles,
          };
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_SUCCESS,
            payload: { edition, assetId },
          });
          console.log(res.data);
          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES.RESET_UNDO,
              payload: {
                articleId: assetId,
                editionId: edition.edition_id,
              },
            });
          }, 30000);
        } else if (res.data?.success === false) {
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_FAIL,
            payload: [],
          });
        } else {
          store.dispatch({
            type: BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_FAIL,
            payload: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
        console.log('OKAY SO WE FAILED TO ADD BROWSER ASSET');
        store.dispatch({
          type: BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_FAIL,
          payload: [],
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log('CATCH: adding to the draft of an article');
  }
};

//* get  browser assets
export const getEmailBrowserList = (params?: any) => {
  store.dispatch({
    type: EMAIL_BROWSER.LOAD,
  });
  const queryParams = objectToQueryParams(params);
  getEmailBrowserListService(queryParams)
    .then((res) => {
      let { data, total_count } = res.data;
      if (data) {
        const serializedEmails = serializeEmailBrowserEmails(data);
        store.dispatch({
          type: EMAIL_BROWSER.LOAD_SUCCESS,
          payload: { emails: serializedEmails, totalCount: total_count },
        });
      }
      if (data.length === 0) {
        resetAssetBrowserSearch();
      }
    })
    .catch((err) => {
      console.log('Error getEmailBrowserList: ', err);
      store.dispatch({
        type: EMAIL_BROWSER.LOAD_FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

export const getEmailBrowserInCampaignList = (params?: any) => {
  store.dispatch({
    type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD,
  });
  const queryParams = objectToQueryParams(params);
  getEmailBrowserListService(queryParams)
    .then((res) => {
      let { data, total_count } = res.data;
      if (data) {
        const serializedEmails = serializeEmailBrowserEmails(data);
        store.dispatch({
          type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_SUCCESS,
          payload: { emails: serializedEmails, totalCount: total_count },
        });
      }
    })
    .catch((err) => {
      console.log('OKAY SO WE FAILED TO FETCH BROWSER ASSETS : ', err);
      store.dispatch({ type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_FAIL });
      // show error alert on frontend
    });
};

export const resetEmailBrowserInCampaignList = () => {
  store.dispatch({ type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.RESET });
};

//* searching assets in the asset list
export const searchBrowserAssetsList = (data: any) => {
  store.dispatch({
    type: EMAIL_BROWSER.SEARCH,
  });
  searchBrowserAssetListService(data)
    .then((res) => {
      if (res.data) {
        console.log('SEARCH IS WORKING ');
        if (res.data.asset_content.length === 0) {
          store.dispatch({
            type: EMAIL_BROWSER.SEARCH_RESET_NO_RESULT,
          });
        } else {
          store.dispatch({
            type: EMAIL_BROWSER.SEARCH_SUCCESS,
            payload: res.data.asset_content,
          });
        }
      } else {
        console.log('SEARCH: Empty result for search');
        store.dispatch({
          type: EMAIL_BROWSER.SEARCH_FAIL,
          payload: [],
        });
      }
    })
    .catch((err) => {
      console.log(err);
      console.log('CATCH: ASSET SEARCH ERROR');
      store.dispatch({
        type: EMAIL_BROWSER.SEARCH_FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

//* Search Assets list in the Campaign
export const searchBrowserAssetsListInCampaign = (data: any, campaignId: any) => {
  store.dispatch({
    type: EMAIL_BROWSER.SEARCH,
  });
  searchBrowserAssetListInCampaignService(data, campaignId)
    .then((res: any) => {
      if (res.data) {
        console.log('SEARCH IS WORKING : ', res);
        if (res.data.length === 0) {
          store.dispatch({
            type: EMAIL_BROWSER.SEARCH_RESET_NO_RESULT,
          });
        } else {
          store.dispatch({
            type: EMAIL_BROWSER.SEARCH_SUCCESS,
            payload: res.data.all_assets,
          });
        }
      } else {
        console.log('SEARCH: Empty result for search');
        store.dispatch({
          type: EMAIL_BROWSER.SEARCH_FAIL,
          payload: [],
        });
      }
    })
    .catch((err: any) => {
      console.log(err);
      console.log('CATCH: ASSET SEARCH ERROR');
      store.dispatch({
        type: EMAIL_BROWSER.SEARCH_FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

//* Reset the asset browser search
export const resetAssetBrowserSearch = () => {
  store.dispatch({
    type: EMAIL_BROWSER.SEARCH_RESET,
  });
};

export const resetArticlesListingOnEditionEdit = () => {
  store.dispatch({ type: ALL_ARTICLES_IN_EDITION.RESET_DATA });
};

//* create new mail if campaignId provided then inside campaign otherwise without campaign
export const createNewEmail = (articles: string, campaignId?: any, onlyCampaign?: boolean) => {
  store.dispatch({
    type: EMAIL_BROWSER_ADD_EMAIL.ADD,
  });
  try {
    createNewEmailService(articles, campaignId)
      .then((res) => {
        // setting hovered Id to 0 so that the email Items should be enabled
        setHoveredAssetId(0);
        if (res.status === 200) {
          let serializedEmail = serializeEmailBrowserCuratedResponse(res.data);
          let isIncludeInEmailsDashboard =
            window.location.pathname.includes('/campaigns/content/source') || window.location.pathname.includes('/campaigns/content/favorites');
          store.dispatch({ type: CAMPAIGNS_LIST.RESET });
          resetArticlesListingOnEditionEdit();
          store.dispatch({
            type: EMAIL_BROWSER_ADD_EMAIL.ADD_SUCCESS,
            payload: {
              email: {
                ...serializedEmail,
                newlyCreated: true,
                recent: true,
                showUndo: true,
                recentlyAddedArticles: articles,
                type: 0,
              },
              campaignId,
              onlyCampaign: onlyCampaign ?? false,
              isIncludeInEmailsDashboard,
            },
          });
          store.dispatch({ type: EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.RESET, payload: true });
          if (campaignId) {
            store.dispatch({
              type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
              campaign_id: campaignId,
              add: true,
            });
          }
          //* remove curation message based on the first time
          let showCurationMessage = store.getState().user.assets;
          if (showCurationMessage) {
            hideCurationMessage();
          }
          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_RECENT,
              payload: { emailId: serializedEmail.emailId },
            });
          }, 5000);
          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_UNDO,
              payload: { emailId: serializedEmail.emailId },
            });
          }, 30000);
        } else if (res.data?.success === false) {
          store.dispatch({ type: EMAIL_BROWSER_ADD_EMAIL.ADD_FAIL });
        } else {
          store.dispatch({ type: EMAIL_BROWSER_ADD_EMAIL.ADD_FAIL });
        }
      })
      .catch((err) => {
        console.log('OKAY SO WE FAILED TO ADD BROWSER ASSET', err);
        store.dispatch({ type: EMAIL_BROWSER_ADD_EMAIL.ADD_FAIL });
        // show error alert on frontend
      });
  } catch (err) {
    console.log("CATCH: couldn't add new assets to the campaign");
  }
};

//*  adding to the draft of a version
//*  articleId is actually
export const addArticlesToEmailInEmailBrowser = (emailId: any, selectedArticles: string, campaignId: any = null, _articleObj?: any) => {
  store.dispatch({
    type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD,
  });
  store.dispatch({
    type: GENERATE_PREVIEW.UPDATE,
    isUpdated: true,
  });
  try {
    addArticlesToEmailInEmailBrowserService(emailId, selectedArticles, campaignId)
      .then((res) => {
        let isFavorites = window.location.pathname.includes('favorites');

        if (res.data?.articles_already_curated) {
          if (isFavorites) {
            store.dispatch({
              type: FAVORITE_NEWS.ADD_CURATE,
              curate_article_id: selectedArticles,
            });
          }
          assetinDraftAlreadyExistOpen();
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_FAIL,
            payload: [],
          });
        } else if (res.status === 200) {
          const { articles_count, last_update, image } = res.data;
          resetArticlesListingOnEditionEdit();
          if (emailId === getQueryEmailId()) {
            if (isFavorites === false) {
              store.dispatch({
                type: SEARCH_ARTICLES.UPDATE_IS_CURATED,
                payload: selectedArticles.toString().split(','),
              });
            } else {
              store.dispatch({
                type: FAVORITE_NEWS.ADD_CURATE,
                curate_article_id: selectedArticles,
              });
              if (_articleObj) {
                store.dispatch({
                  type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_FROM_FAVORITES,
                  payload: _articleObj,
                });
              }
            }
            store.dispatch({
              type: ALL_ARTICLES_IN_EDITION.UPDATE_CURATED_COUNT,
              payload: selectedArticles.toString().split(',')?.length,
            });
            setDesignUpdate(true);
          }

          // if inside campaign it will update email's thumbnails
          store.dispatch({
            type: EMAIL_LIST.DRAFT_UPDATE_IMAGES,
            payload: {
              images: [...image],
              email_id: emailId,
            },
          });

          store.dispatch({
            type: WHN_ARTICLES.UPDATE_CURATED_COUNT,
            payload: selectedArticles.toString().split(',').length,
          });
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.SET_PREVIEW,
            payload: {
              img: store.getState().dragDrop.newPreviewImage,
              emailId,
              articles: selectedArticles.toString(),
              articles_count,
              last_update,
              images: [...image],
            },
          });

          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_RECENT,
              payload: {
                emailId,
              },
            });
          }, 5000);

          setTimeout(() => {
            store.dispatch({
              type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET_UNDO,
              payload: { emailId },
            });
          }, 30000); // reset after 30 seconds

          removeSelectedIds();
        } else if (res.data?.success === false) {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_FAIL,
            payload: [],
          });
        } else {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_FAIL,
            payload: [],
          });
        }

        setTimeout(() => {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.RESET,
          });
          store.dispatch({
            type: DRAG_DROP.SET_IMAGE,
            payload: '',
          });
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
        store.dispatch({
          type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_FAIL,
          payload: [],
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log('CATCH: could not add draft in asset');
  }
};

export const setDesignUpdate = (flag: boolean) => {
  store.dispatch({ type: DESIGN.SET_DESIGN_UPDATE, payload: flag ?? false });
};

export const undoCurationFromEmail = (emailId: any, selectedArticles: any) => {
  undoCurationFromEmailService(emailId, selectedArticles)
    .then((response) => {
      console.log('Response undoCurationFromEmail: ', response);
      if (response.data.success) {
        store.dispatch({
          type: EMAIL_BROWSER_CURATION_UNDO.SUCCESS,
          payload: {
            emailId,
            articles: selectedArticles,
          },
        });
        setDesignUpdate(true);
        setTimeout(() => {
          store.dispatch({
            type: EMAIL_BROWSER_CURATION_UNDO.RESET,
            payload: {
              emailId,
            },
          });
        }, 3000);
      }
    })
    .catch((err) => {
      console.log('Error : ', err);
    });
};

export const hideCurationMessage = () => {
  store.dispatch({
    type: EMAIL_BROWSER_ON_BOARDING.SET_SHOW,
    payload: { value: 0 },
  });
  const values: any = {
    key: ON_BOARDING_ENUMS.ASSETS,
    step: '0',
  };
  values[ON_BOARDING_ENUMS.ASSETS] = '0';
  setOnBoardingStepService(values)
    .then((res) => {
      console.log('setCampaignEmails Response : ', res);
    })
    .catch((err) => {
      console.log('Error : ', err);
    });
};

export const deleteNewlyCreatedDraft = (asset_id: any, version_id: any) => {
  deleteNewlyCreatedDraftService(version_id)
    .then((response) => {
      console.log('deleteNewlyCreatedDraftService Response: ', response);
      store.dispatch({
        type: BROWSER_REMOVE_ASSET_DRAFT.SUCCESS,
        payload: {
          assetId: asset_id,
          editionId: version_id,
        },
      });
      store.dispatch({
        type: ASSET_DETAILS_REMOVE_DRAFT.SUCCESS,
        payload: {
          versionId: version_id,
        },
      });
    })
    .catch((err) => {
      console.log('deleteNewlyCreatedDraftService Error: ', err);
    });
};

export const deleteNewlyCreatedDraftAssetWithoutCampaign = (asset_id: any, version_id: any) => {
  deleteNewlyCreatedDraftService(version_id)
    .then((response) => {
      console.log('deleteNewlyCreatedDraftService Response: ', response);
      store.dispatch({
        type: BROWSER_REMOVE_ASSET_DRAFT.SUCCESS,
        payload: {
          assetId: asset_id,
          editionId: version_id,
        },
      });
      store.dispatch({
        type: ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.SUCCESS,
        payload: {
          versionId: version_id,
        },
      });
    })
    .catch((err) => {
      console.log('deleteNewlyCreatedDraftService Error: ', err);
    });
};

// ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.SUCCESS

//*  adding to the draft of a version
export const addToBrowserAssetDraftWithoutCampaign = (articleId: any, editionId: number, selectedArticles: string) => {
  console.log('printing the value passed to Browser Assets');
  store.dispatch({
    type: EMAIL_BROWSER_ADD_ARTICLES.ADD,
  });

  try {
    addArticlesToEmailInEmailBrowserService(editionId, selectedArticles)
      .then((res: any) => {
        if (res.data.articles_already_curated) {
          assetinDraftAlreadyExistOpen();
        } else if (res.data?.success) {
          const { total_curated_articles } = res.data;
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES.ADD_SUCCESS,
            payload: true,
          });
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES.SET_PREVIEW,
            payload: {
              img: store.getState().dragDrop.newPreviewImage,
              articleId,
              editionId,
              total_curated_articles,
            },
          });

          removeSelectedIds();
        } else if (res.data?.success === false) {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES.ADD_FAIL,
            payload: [],
          });
        } else {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES.ADD_FAIL,
            payload: [],
          });
        }

        setTimeout(() => {
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES.RESET,
          });
          store.dispatch({
            type: DRAG_DROP.SET_IMAGE,
            payload: '',
          });
        }, 3000);
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: EMAIL_BROWSER_ADD_ARTICLES.ADD_FAIL,
          payload: [],
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log('CATCH: could not add draft in asset');
  }
};

//* adding to browser asset draft
export const addToBrowserNewAssetDraft = (editionId: number, selectedArticles: string) => {
  store.dispatch({
    type: BROWSER_CREATED_ASSET_DRAFT.ADD,
  });

  try {
    addArticlesToEmailInEmailBrowserService(editionId, selectedArticles)
      .then((res: any) => {
        console.log('ADD TO BROWSER ASSET DRAFT SERVICE');
        if (res.status === 200) {
          store.dispatch({
            type: BROWSER_CREATED_ASSET_DRAFT.ADD_SUCCESS,
            payload: true,
          });
        } else if (res.data?.success === false) {
          store.dispatch({
            type: BROWSER_CREATED_ASSET_DRAFT.ADD_FAIL,
            payload: [],
          });
        } else {
          store.dispatch({
            type: BROWSER_CREATED_ASSET_DRAFT.ADD_FAIL,
            payload: [],
          });
        }
        if (res.data.articles_already_curated) {
          assetinDraftAlreadyExistOpen();
        }

        setTimeout(() => {
          store.dispatch({
            type: BROWSER_CREATED_ASSET_DRAFT.RESET,
          });
        }, 3000);
      })
      .catch((err: any) => {
        console.log(err);
        store.dispatch({
          type: BROWSER_CREATED_ASSET_DRAFT.ADD_FAIL,
          payload: [],
        });
        store.dispatch({
          type: DRAG_DROP.SET_IMAGE,
          payload: '',
        });
        // show error alert on frontend
      });
  } catch (err) {
    console.log('CATCH: could not add draft in asset');
  }
};

//* get  browser assets for the campaign tab
export const getBrowserAssetsListForCampaign = (campaign_id: any) => {
  store.dispatch({
    type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD,
  });
  getBrowserAssetsForCampaignService(campaign_id)
    .then((res) => {
      store.dispatch({
        type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_SUCCESS,
        payload: res.data.campaign_assets,
      });
      store.dispatch({
        type: EMAIL_BROWSER.LOAD_SUCCESS,
        payload: { assets: res.data.all_assets, assetsCount: res.data.all_asset_count },
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: EMAIL_BROWSER_EMAILS_IN_CAMPAIGN.LOAD_FAIL,
      });
      // show error alert on frontend
    });
};

export const assetinDraftAlreadyExistOpen = () => {
  store.dispatch({
    type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ALREADY_ADDED_OPEN,
  });
};

export const assetinDraftAlreadyExistClose = () => {
  store.dispatch({
    type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ALREADY_ADDED_CLOSE,
  });
};

export const getAllAssetsInCampaign = (data: any) => {
  store.dispatch({
    type: GET_ALL_ASSETS_IN_CAMPAIGN,
    payload: data,
  });
};

export const updateAssetCountSidebarIcon = (add: boolean = true) => {
  store.dispatch({
    type: EMAIL_BROWSER.CHANGE_TOTAL_ASSET_COUNT,
    payload: {
      add: add,
    },
  });
  setTimeout(() => {
    store.dispatch({
      type: EMAIL_BROWSER.RESET_COLOR,
    });
  }, 30000);
};

export const removeEmailFromEmailBrowserList = (emailId: any, campaignId?: any, generationId?: any) => {
  return removeEmailFromEmailBrowserListService(emailId, campaignId, generationId)
    .then((res) => {
      store.dispatch({
        type: EMAIL_BROWSER.REMOVE_EMAIL,
        payload: {
          emailId,
          campaignId,
        },
      });
      if (window.location.pathname.includes('source'))
        store.dispatch({
          type: EMAIL_LIST.DRAFT_EMAILS_RESET_LOAD,
          payload: true,
        });
    })
    .catch((error) => {});
};
export const addCampaignAgainstEmailInEmailBrowser = (emailId: any, campaignId?: any, campaignName?: string) => {
  store.dispatch({
    type: BROWSER_ADD_ASSET_WITH_CAMPAIGN.ADD_CAMPAIGN,
    payload: {
      emailId,
      campaignId,
      campaignName,
    },
  });
};

export const updateEmailNameForBrowserEmailList = (emailName: any, emailId?: any, generationId?: string) => {
  if (emailId) {
    store.dispatch({ type: EMAIL_BROWSER.SET_EMAIL_NAME, payload: { emailName, emailId } });
  }
  if (generationId) {
    const aiEmails = store.getState().aiEmail.emails;
    aiEmails.forEach((email) => {
      store.dispatch({ type: EMAIL_BROWSER.SET_EMAIL_NAME, payload: { emailName, emailId: email.emailId } });
    });
  }
  updateEmailNameService(emailName, emailId, generationId)
    .then((res) => {
      if (generationId) {
        store.dispatch({
          type: AIEMAIL.UPDATE_NAME,
          payload: emailName,
        });
      }
      store.dispatch({
        type: DESIGN.EMAIL_NAME_UPDATE,
        payload: emailName,
      });
      if (store.getState().automation.workflow.detail.id) {
        store.dispatch(resetWorkflow());
      }
      updateAnEmailInEmailListingAnalytics(emailId, 'name', emailName);
    })
    .catch((err) => {
      console.log('Error updateEmailNameService: ', err);
    });
};

export const removeEmailWithoutCampaign = (emailId: any) => {
  store.dispatch({
    type: EMAIL_BROWSER.REMOVE_EMAIL,
    payload: { emailId },
  });
};

export const resetEmailListInEmailBrowser = () => {
  store.dispatch({
    type: EMAIL_BROWSER.RESET,
  });
};
